import {
    QUALITY_EVENT_ACTIONS,
    QUALITY_EVENT_NAME
} from '../../../layouts/main/header/components/pricing-policy-modal/pricing-polic- modal.constants';
import { storageKeys } from '../../../utils/browser-storage/storage-keys';
import detectBrowser from '../../../utils/detect-browser';
import detectDevice from '../../../utils/detect-device';
import qualityEventsHelpers from '../quality-events.helpers';

export const HEADER_EVENTS = {
    allocatedCreditsCampaignPopup() {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                user_id: window.storage.getItem(storageKeys.user.userId)
            }),
            page_url: window.location.href,
            type: 'allocatedCreditsCampaign:popupShown',
            user_agent: detectBrowser(),
            user_device: detectDevice()
        });
    },
    pricePolicyModalEvent(action: QUALITY_EVENT_ACTIONS) {
        qualityEventsHelpers.track({
            type: QUALITY_EVENT_NAME,
            extra: action
        });
    },
    clickAiToolsIcon() {
        qualityEventsHelpers.track({
            type: 'clickAiToolsIcon'
        });
    }
};
